// Angular
import { Injectable } from "@angular/core";

// Services
import { ConfigService } from "#services/config/config.service";

@Injectable({
    providedIn: "root",
})
export class EnvService extends ConfigService {
    configs: Record<string, string> = {};

    init() {
        this.getConfigs().subscribe(({ data }) => {
            data.forEach((config) => {
                this.configs[config.key] = config.value;
            });
        });
    }

    getAll() {
        return this.configs;
    }

    get(key: string) {
        if (key in this.configs) {
            return this.configs[key];
        }

        console.warn("EnvService: Undefined environment key");

        return null;
    }
}
